module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bakery@2x_104042.jpg";